// Import Dependencies
import { Navigate } from "react-router";

// Local Imports
import { AppLayout } from "app/layouts/AppLayout";
import { DynamicLayout } from "app/layouts/DynamicLayout";
import AuthGuard from "middleware/AuthGuard";

// ----------------------------------------------------------------------

const protectedRoutes = {
  id: "protected",
  Component: AuthGuard,
  children: [
    // The dynamic layout supports both the main layout and the sideblock.
    {
      Component: DynamicLayout,
      children: [
        {
          path: "dashboards",
          children: [
            {
              index: true,
              element: <Navigate to="/dashboards/home" />,
            },
            {
              path: "home",
              lazy: async () => ({
                Component: (await import("app/pages/dashboards/home")).default,
              }),
            },{
              path: "evaluations",
              lazy: async () => {
                const CurrentPage = (
                  await import("app/pages/dashboards/evaluations")
                ).default;

                return {
                  Component: () => (
                    // <RoleGuard userAllowRole={200000}>
                      <CurrentPage />
                    // </RoleGuard>
                  ),
                };
              },
            },
          ],
        },

        // Raajneeti AI module
        {
          path: "raajneeti",
          children: [
            {
              index: true,
              element: <Navigate to="/raajneeti/home" />,
            },
            {
              path: "home",
              lazy: async () => ({
                Component: (await import("app/pages/raajneeti/home/index"))
                  .default,
              }),
            },
            {
              path: "psir",
              lazy: async () => ({
                Component: (await import("app/pages/raajneeti/psir/index"))
                  .default,
              }),
            },
            {
              path: "know-a-thinker",
              lazy: async () => ({
                Component: (
                  await import("app/pages/raajneeti/knowThinker/index")
                ).default,
              }),
            },
            {
              path: "current-affairs",
              lazy: async () => ({
                Component: (
                  await import("app/pages/raajneeti/currentAffairs/index")
                ).default,
              }),
            },

           
            {
              path: "revision-hub",
              lazy: async () => ({
                Component: (
                  await import("app/pages/raajneeti/revisionHub/index")
                ).default,
              }),
            },
            {
              path: "ai-samiksha",
              lazy: async () => ({
                Component: (
                  await import("app/pages/raajneeti/aiSamiksha/index")
                ).default,
              }),
            },
            {
              path: "prelims",
              lazy: async () => ({
                Component: (await import("app/pages/raajneeti/prelims/index"))
                  .default,
              }),
            },
            {
              path: "mock-test",
              lazy: async () => ({
                Component: (await import("app/pages/raajneeti/mockTest/index"))
                  .default,
              }),
            },
            {
              path: "mentors",
              lazy: async () => ({
                Component: (await import("app/pages/raajneeti/mentors/index"))
                  .default,
              }),
            },
          ],
        },

        // Payment gateway return pages (ICICI returnurl lands on one of these)
        {
          path: "payment-success",
          lazy: async () => ({
            Component: (
              await import("app/pages/raajneeti/payment/Paymentsuccess")
            ).default,
          }),
        },
        {
          path: "payment-failed",
          lazy: async () => ({
            Component: (
              await import("app/pages/raajneeti/payment/PaymentFailed")
            ).default,
          }),
        },
        {
          path: "payment-pending",
          lazy: async () => ({
            Component: (
              await import("app/pages/raajneeti/payment/PaymentPending")
            ).default,
          }),
        },
      ],
    },
    // The app layout supports only the main layout. Avoid using it for other layouts.
    {
      Component: AppLayout,
      children: [
        {
          path: "settings",
          lazy: async () => ({
            Component: (await import("app/pages/settings/Layout")).default,
          }),
          children: [
            {
              index: true,
              element: <Navigate to="/settings/appearance" />,
            },
            // {
            //   path: "general",
            //   lazy: async () => ({
            //     Component: (await import("app/pages/settings/sections/General"))
            //       .default,
            //   }),
            // },
            {
              path: "appearance",
              lazy: async () => ({
                Component: (
                  await import("app/pages/settings/sections/Appearance")
                ).default,
              }),
            },
          ],
        },
      ],
    },
  ],
};

export { protectedRoutes };